module.exports = __webpack_public_path__ + "img/celebration.ce7cbf7b.svg";